// @flow
// ----------------------------------------------------------------------
// <copyright file="Izenda.ImportOverwriteInfoTree.js" company="Izenda">
//  Copyright (c) 2018 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

import React, { Component } from 'react';
import connect from 'share/enhancers/Izenda.Connect';
import TreeView from 'share/components/controls/Izenda.TreeView';
import { get } from 'lodash/fp';
import Input from 'share/components/controls/Izenda.Input';
import TextHighLight from 'share/components/controls/Izenda.TextHighLight';
import { propTypes as MobxPropTypes } from 'mobx-react';
import classnames from 'classnames';

@connect()
export default class ImportOverwriteOptionTree extends Component {
  static propTypes = {
    overwriteOptionTree: MobxPropTypes.arrayOrObservableArray.isRequired
  };

  renderNode = (node: any, toggleIcon: any) => {
    const onChange = (e: Event) => {
      node.changeNodeStatus(e.target.checked);
    };

    const textClassName = classnames({ unchecked: !node.checked && node.isLeafNode });

    return (
      <div className="checkbox u_noMarginAll">
        <label>
          <Input type="checkbox" checked={node.checked} onChange={onChange} indeterminate={node.indeterminate} />
          <TextHighLight
            className={textClassName}
            text={node.name}
            tooltip={node.name}
          />
          {node.checked && node.isLeafNode && <span className="icon-ok checked" />}
        </label>
        {toggleIcon}
      </div>
    );
  };

  render() {
    const { overwriteOptionTree } = this.props;
    return (
      <div className="tree-content u_borderAll">
        <TreeView
          nodes={overwriteOptionTree}
          getKey={get('key')}
          getChildNodes={get('childs')}
          renderNode={this.renderNode}
          collapsed={false}
        />
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./ui/modules/Settings/DataSetup/Import/Popup/Izenda.ImportOverwriteOptionTree.js